import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte, BokkzAlgDataService, IncomeTaxEntity,
    LoonBuitenland,
    OmschrijvingEnBedrag
} from '@snelstart-ventures/fiscaal/domain-logic';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { optionsLandcodesZonderNLDBLDGDUI } from '../../../gedeelde-componenten/gedeelde-componenten.component';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-loon-buitenland',
    templateUrl: './loon-buitenland.component.html',
    styleUrls: ['./loon-buitenland.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiDialogModule,
        SharedUiDetailsModule,
        CommonModule
    ]
})

export class LoonBuitenlandComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;

    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte;

    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null;

    public loonBuitenland = {} as FormGroup;

    public dialogVisible = false;

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }

    public index = 0;

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        { value: true, label: 'Ja' },
        { value: false, label: 'Nee' }
    ];

    public optionsJaNeeSter: SelectFormControlItem<boolean>[] = [
        { value: true, label: 'Ja*' },
        { value: false, label: 'Nee' }
    ];

    public optionsTegenwoordig: SelectFormControlItem<boolean>[] = [
        { value: false, label: 'Vroeger (pensioen)' },
        { value: true, label: 'Tegenwoordig (werk)' },
    ];

    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesZonderNLDBLDGDUI;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.loonBuitenland = this.fb.group({
            loonUitBuitenland: this.fb.array<LoonBuitenland>([])
        });
    }

    get loonUitBuitenland(): FormArray {
        return this.loonBuitenland.get('loonUitBuitenland') as FormArray;
    }

    addRijLoonBuitenland(): void {
        this.loonUitBuitenland.push(this.createLoonBuitenlandFormGroup()
        );
    }

    verwijderRijLoonBuitenland(index: number): void {
        this.loonUitBuitenland.removeAt(index);
        this.loonBuitenland.updateValueAndValidity();
        this.loonBuitenland.markAsDirty();
        this.saveForm();
    }

    createLoonBuitenlandFormGroup(loon?: LoonBuitenland): FormGroup {
        return this.fb.group(({
            loon: this.fb.group(({
                omschrijving: loon ? loon.loon?.omschrijving : undefined,
                bedrag: loon ? loon.loon?.bedrag : undefined
            } as OmschrijvingEnBedrag)),
            loonheffing: loon ? loon.loonheffing : null,
            loonsoort: loon ? loon.loonsoort : null,
            landCode: loon ? loon.landCode : undefined,
            loonUitTegenwoordigeBuitenlandseDienstbetrekking: loon ? loon.loonUitTegenwoordigeBuitenlandseDienstbetrekking : undefined,
            belastDeelLoonInNederland: loon ? loon.belastDeelLoonInNederland : 0,
            buitenlandseLoonheffing: loon ? loon.buitenlandseLoonheffing : undefined,
            inkomenZitInNederlandseGrondslag: loon ? loon.inkomenZitInNederlandseGrondslag : false,
            pasVerrekenMethodeToe: loon ? loon.pasVerrekenMethodeToe : false,
            afdrachtZVWinNLmoetnog: loon ? loon.afdrachtZVWinNLmoetnog : true,
            benutAlgemeneCompensatieregeling: loon ? loon.benutAlgemeneCompensatieregeling : false,
            benutBijzondereCompensatieregeling: loon ? loon.benutBijzondereCompensatieregeling : false,
            compensatieregelingDuitsland: loon ? loon.compensatieregelingDuitsland : false,
            veranderingVanWerkgever: loon ? loon.veranderingVanWerkgever : false,
            inBelgieOfDuitslandIngehoudenBelasting: loon ? loon.inBelgieOfDuitslandIngehoudenBelasting : undefined
        } as LoonBuitenland));
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner;
                    this.loonBuitenland.reset();
                    this.updateForm();
                });
            }
        });
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.loonBuitenland.dirty;
    }

    private updateForm(): void {
        let loonBuitenlandLijst = this.aangifte?.box1?.belastbaarLoon?.loonUitBuitenlandseDienstbetrekkingOfPensioen || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                loonBuitenlandLijst = this.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.loonUitBuitenlandseDienstbetrekkingOfPensioen || [];
            }
        });

        const formArray = this.loonBuitenland.get('loonUitBuitenland') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > loonBuitenlandLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < loonBuitenlandLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(loonBuitenlandLijst[i]);
            } else {
                const formGroup = this.createLoonBuitenlandFormGroup(loonBuitenlandLijst[i]);
                formArray.push(formGroup);
            }

            if (this.loonUitBuitenland.controls[i].get('pasVerrekenMethodeToe')?.value === false) {
                this.loonUitBuitenland.controls[i].get('buitenlandseLoonheffing')?.setValue(0);
            }
            if ((this.loonUitBuitenland.controls[i].get('compensatieregelingDuitsland')?.value === false || this.loonUitBuitenland.controls[i].get('compensatieregelingDuitsland')?.value === undefined) &&
                (this.loonUitBuitenland.controls[i].get('benutAlgemeneCompensatieregeling')?.value === false || this.loonUitBuitenland.controls[i].get('benutAlgemeneCompensatieregeling')?.value === undefined) &&
                (this.loonUitBuitenland.controls[i].get('benutBijzondereCompensatieregeling')?.value === false || this.loonUitBuitenland.controls[i].get('benutBijzondereCompensatieregeling')?.value === undefined)) {
                this.loonUitBuitenland.controls[i].get('inBelgieOfDuitslandIngehoudenBelasting')?.setValue(0);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            if (!this.partnerBoolean) {
                this.incomeTaxEntity.aangifte = {
                    ...this.aangifte,
                    box1: {
                        ...this.aangifte.box1,
                        belastbaarLoon: {
                            ...this.aangifte.box1?.belastbaarLoon,
                            loonUitBuitenlandseDienstbetrekkingOfPensioen: this.loonBuitenland.value.loonUitBuitenland
                        }
                    }
                } as Aangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            } else {
                this.incomeTaxEntity.aangifte = {
                    ...this.aangifte,
                    partnerAangifte: {
                        ...this.aangifte.partnerAangifte,
                        box1: {
                            ...this.aangifte.partnerAangifte?.box1,
                            belastbaarLoon: {
                                ...this.aangifte.partnerAangifte?.box1?.belastbaarLoon,
                                loonUitBuitenlandseDienstbetrekkingOfPensioen: this.loonBuitenland.value.loonUitBuitenland
                            }
                        }
                    }
                } as Aangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            }
            this.loonBuitenland.markAsDirty();
        }, 0);
    }
}

